import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicProjectAvailableAssetsParamsRawI,
	type LWApiPublicProjectAvailableAssetsResultRawI,
} from '@liquidweb-dev/club-sauce/public/project/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const PROJECT_AVAILABLE_ASSETS_QUERY_KEY = '/project/availableAssets';

const useProjectAvailableAssets = (
	params: LWApiPublicProjectAvailableAssetsParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicProjectAvailableAssetsResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [PROJECT_AVAILABLE_ASSETS_QUERY_KEY, params],
		queryFn: () => api.project.apiRaw.availableAssets(params),
		...options,
	});

export default useProjectAvailableAssets;
